import { lazy } from "react";

export { OPPORTUNITIES_PATH } from "./oportunities-path";
export const OpportunitiesPage = lazy(() => import("./opportunities-page"));
